import * as React from 'react';
import SiteMapType, { SiteMapLink } from '../../models/siteMap';
import Text from '../Text';
import './style.scss';
import Extend from '../icons/Extend';
import classNames from 'classnames';
import SiteMapColumn from './column';
import Stormotion from '../icons/Stormotion';

interface Props {
  siteMap: SiteMapType[];
}

const SiteMap: React.SFC<Props> = ({ siteMap }) => {
  return (
    <div className={'site-map'}>
      <div className="site-map__column">
        <Stormotion dark={false} />
      </div>
      {siteMap.map((item: SiteMapType, index: number) => (
        <SiteMapColumn
          key={`site-map-${item.title}-${index}`}
          item={item}
          index={index}
        />
      ))}
    </div>
  );
};

export default SiteMap;
